import React from 'react'
import { API_URL } from '../Constants'
import { SectionBase, DifficultyBadge, Time, NextQuestion} from '../Shared/SectionBase'
import { Link } from 'react-router-dom'
import Menu from '../Shared/Menu';
import TargetWord from './TargetWord';

export default class ReadAndComplete extends SectionBase  {
  
  constructor(props) {
    super(props)
    this.nextQuestion = this.nextQuestion.bind(this);
    this.onBackspace = this.onBackspace.bind(this)
    this.onDifficultyChange = this.onDifficultyChange.bind(this);
    this.setWordFocus = this.setWordFocus.bind(this);
    this.onLetterClick = this.onLetterClick.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.retry = this.retry.bind(this);
    this.submit = this.submit.bind(this)
  }

    TEST_TIME_SECONDS = 120

    state = {
        difficulty:1
    }

    getAllTargetLetters(parts){
      const targetWords = parts.filter(p=>p.is_target).map(p=>p.word);
      const allLetters = [];
      console.log(targetWords);
      targetWords.forEach(w=>{allLetters.push(...w.toLowerCase())});
      allLetters.sort();
      return Array.from(new Set(allLetters));
    }
    
    async nextQuestion(){
        console.log('nextQ');
        const secondsLeft = this.TEST_TIME_SECONDS;
        const step = 1;
        const {difficulty} = this.state;
        const { token } = this.props;
    
          const res = await fetch(`${API_URL}/readandcomplete/createquestion/${difficulty}`,
            { headers: { Authorization: `Token ${token}` } });
          try {
            const result = await res.json();
            const reading_dump = result[0].reading;
            const reading_id = result[0].id;
            const parts = this.prepareParts(result[0].parts, true);
            const targetLetters = this.getAllTargetLetters(parts);  
            console.log(targetLetters); 
            console.log(parts);
            console.log(secondsLeft);
            this.setState({ reading_id, reading_dump, parts, targetLetters, secondsLeft, step },this.restartTimer);
            
          } catch (e) {
            console.log(e);
            console.log(res);
          }
      }


    onTimeIsUp(){
        this.setState({step:2})
    }

  onBackspace(){
    let parts = this.state.parts.filter(p=>p.is_focus);
    if (parts.length>0){
      const part = parts[0];
      if (part.answer.length>part.hint_length){
        part.answer = part.answer.slice(0, part.answer.length-1);
      }
      }
  }

  onDifficultyChange(e){
    this.setState({difficulty:e.target.value}, this.nextQuestion);
    
  }

  onKeyUp(e){
    try{
      const key = e?.key?.toLowerCase();
      if ( /^[a-z]$/.test(key)){
        this.onLetterClick(key);
      }
      if (key==='backspace'){
        this.onBackspace();
      }
     
    }catch(err){
      console.log('onKeyUp error:');
      console.log(err)

    }
    
    }

  onLetterClick(l){
    let parts = [...this.state.parts];
    for (var i=0;i<parts.length;i++){
      if (parts[i].is_focus){
          const part = parts[i];
          if (part.answer.length<part.word.length){
            part.answer +=l;
            //console.log(part.answer);
          }
      }
    // TODO auto go to the next word
    }
    
    this.setState({parts})

  }

  prepareParts(parts, setFocusOnFirst){
    let firstTargetInd = null;
    for (var i=0;i<parts.length;i++){
      if (parts[i].is_target){
        parts[i].is_focus = false;
        if (firstTargetInd === null){
          firstTargetInd = i;
        }
        let word = parts[i].text;
        const hint_length = ~word.indexOf('|')? word.split('|')[0].length : Math.floor(word.length/2);
        word = word.replace('|','')
        parts[i].hint_length = hint_length;
        parts[i].word = word;
        parts[i].answer = word.slice(0,hint_length);
      }
    }

    if (setFocusOnFirst) parts[firstTargetInd].is_focus = true;
    
    return parts;
  }
  
  render() {
        const { token } = this.props;
    
        const { parts, secondsLeft, step, profile, difficulty, targetLetters } = this.state;
        
        return (
          <>
            {token!==null && parts && <div className={`readandcomplete readandcomplete-step${step}`}>
              <Menu token={token}  profile={profile}onDifficultyChange={this.onDifficultyChange}></Menu>
              <Time seconds={secondsLeft}></Time>
              <DifficultyBadge difficulty={difficulty}></DifficultyBadge>
              <div className='px-5' >
                <h1 className='text-center'>Type the missing letters to complete the paragraph below</h1>
                <div className='parts my-5'>{ parts.map((p, partInd) => {
                  p.elementKey = `part-${partInd}`;
                  if (p.is_target){
                    return <TargetWord showCorrect={step>1} disabled={step>1} key={p.elementKey} isFocus={p.is_focus}  word={p.word} answer={p.answer} hintLength={p.hint_length} onFocus={()=>{this.setWordFocus(partInd)}}></TargetWord>
                  }else{
                    return <div  key={p.elementKey} className='text-muted d-inline'>{p.text}</div>
                  }
                })}</div>
                
                {step === 1 && <div className='text-center letters'>
                {targetLetters.map((l,i)=><button onClick={()=>{this.onLetterClick(l)}} className='btn btn-light m-1' key={`letter-${l}`}>{l}</button>)}
                <button className='btn btn-light m-1' onClick={this.onBackspace}>⌫</button>
                  </div>} 

                {step >= 2 && <>
                  <div className='result mb-2'>
                    <div className='custom-box-1 my-5 bg-light m-auto p-3'>
                      <h4>Correct Answer</h4>
                      { parts.map((p, partInd) => {
                    p.elementKey = `part-correct-${partInd}`;
                    if (p.is_target){
                      return <div key={p.elementKey} className='d-inline fw-bold bg-warning btn-correct-word btn'>{p.word}</div>
                    }else{
                      return <div  key={p.elementKey} className='d-inline'>{p.text}</div>
                    }
                  })}</div>
                </div>
                  
                </>
                }
    
              
    
                <div className='buttons d-flex justify-content-between'>
                  <button type="button" className={`btn btn-dark rounded-pill`} onClick={this.retry}>RETRY</button>
    
                  {step === 1 && <button type="button" className={`btn btn-dark rounded-pill`} onClick={this.submit}>SUBMIT</button>
                  }
                </div>
                <NextQuestion nextQuestion={this.nextQuestion}></NextQuestion>
                {false && <div>{JSON.stringify(this.state)}</div>}
              </div>
            
            </div>}
            
            {token === null && <div className='p-5'>Please <Link to="/home/">login</Link> and refresh this page</div>}

          </>
    
        )
      }

  
  retry() {
    const parts = this.prepareParts([...this.state.parts],true );
    this.setState({ parts, step: 1, secondsLeft: this.TEST_TIME_SECONDS });
    this.restartTimer();
  }
  
  async submit(){
    const {parts,reading_dump, reading_id} = this.state;
    let submittedWords = []
    for (var i=0;i<parts.length;i++){
      const p = parts[i];
      if (p.is_target){
        submittedWords.push({
          word:p.word,
          answer:p.answer,
          part_ind:i,
          reading:reading_id,
          reading_dump:reading_dump
        })
      }
    }
   
    console.log(submittedWords);
    this.stopTimer();
    this.setState({ step: 2 });
    const res = await fetch(`${API_URL}/readandcomplete/readingsubmittedwords`, {
      method: 'POST',
      body: JSON.stringify(submittedWords),
      headers: { Authorization: `Token ${this.props.token}`,"Content-Type": "application/json" } 
    });
    const data = await res.json();

    console.log(data);
    
  }

  setWordFocus(i){
      
      const {parts} = this.state;
      for (var j=0;j<parts.length;j++){
        parts[j].is_focus = j===i?true:false;
      }
      this.setState({parts});
  }
}
